export default {"src":"/_next/static/media/gift.7de619ef.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};